import { useFormikContext } from "formik";
import { Stack, TextField, Box, Typography } from "@mui/material";
import get from "lodash/get";
import SwitchSetting from "./SwitchSetting";
import Setting from "./Setting";
import useOrganizationPlan from "@/hooks/useOrganizationPlan";
import FeatureLock from "@/components/FeatureLock";
import { GiftIcon } from "@hugeicons/core-free-icons";

const LoyaltySettingsSection = () => {
  const { isFeatureAvailable } = useOrganizationPlan("loyalty");
  const { values, handleChange } = useFormikContext<any>();

  if (!isFeatureAvailable("rewards")) {
    return (
      <FeatureLock
        icon={GiftIcon}
        title="Sistema de Fidelización por Puntos"
        description="Premia la lealtad de tus clientes permitiéndoles acumular puntos por cada compra. Ideal para aumentar la retención y frecuencia de visitas. Disponible exclusivamente en el Plan Pro."
      />
    );
  }

  return (
    <Stack spacing={2}>
      <Box>
        <Stack spacing={2}>
          <SwitchSetting
            field="settings.loyaltyProgram.isEnabled"
            title="Activar Programa"
            description="Permite a tus clientes acumular puntos por sus compras"
          />

          <Setting
            title="Nombre del Programa"
            description="Ej: Puntos Burger, KornCoins, etc."
          >
            <TextField
              fullWidth
              name="settings.loyaltyProgram.programName"
              value={get(values, "settings.loyaltyProgram.programName", "")}
              onChange={handleChange}
              placeholder="Nombre del programa"
              size="small"
              sx={{ maxWidth: 300 }}
            />
          </Setting>

          <Setting
            title="Relación de Puntos"
            description="Indica cuánto dinero debe gastar el cliente para ganar 1 punto"
          >
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body2">1 Punto =</Typography>
              <TextField
                type="number"
                name="settings.loyaltyProgram.pointsPerAmount"
                value={get(values, "settings.loyaltyProgram.pointsPerAmount", "")}
                onChange={handleChange}
                size="small"
                sx={{ width: 100 }}
                InputProps={{
                  startAdornment: <Typography sx={{ mr: 1 }}>C$</Typography>,
                }}
              />
              <Typography variant="body2">en compras</Typography>
            </Stack>
          </Setting>
        </Stack>
      </Box>
    </Stack>
  );
};

export default LoyaltySettingsSection;
